import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedCompanyStudyReasonApiService } from './company-study-reason-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyStudyReasonApiService extends GeneratedCompanyStudyReasonApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
